(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentAccessInfoDialogController', AgentAccessInfoDialogController);

    AgentAccessInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentAccessInfo'];

    function AgentAccessInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentAccessInfo) {
        var vm = this;

        vm.agentAccessInfo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentAccessInfo.id !== null) {
                AgentAccessInfo.update(vm.agentAccessInfo, onSaveSuccess, onSaveError);
            } else {
                AgentAccessInfo.save(vm.agentAccessInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentAccessInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
